import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../hooks/use-toast';
import { ShieldCheck } from 'lucide-react';
import { LOGO_URL } from '../mock';

const Login = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const { toast } = useToast();
  const [email, setEmail] = React.useState('');
  const [pw, setPw] = React.useState('');
  const [busy, setBusy] = React.useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !pw) return;
    setBusy(true);
    const res = await login(email, pw);
    setBusy(false);
    if (!res.ok) {
      toast({ title: 'Inloggen mislukt', description: res.error || 'Onjuiste inloggegevens.', variant: 'destructive' });
      return;
    }
    toast({ title: 'Welkom terug', description: res.user.name });
    nav('/admin');
  };

  return (
    <div className="min-h-[75vh] flex items-center justify-center bg-slate-50 py-14 px-4">
      <Card className="w-full max-w-md p-8 border border-slate-200">
        <div className="flex items-center gap-3 mb-5">
          <img src={LOGO_URL} alt="Bezwaarmeesters" className="h-9 w-auto" />
        </div>
        <div className="flex items-center gap-2 text-slate-500 text-xs uppercase tracking-widest">
          <ShieldCheck className="w-4 h-4 text-[#f26b1f]" /> Admin login
        </div>
        <h1 className="text-2xl font-bold text-[#1e1b4b] mt-1">Inloggen</h1>
        <p className="text-sm text-slate-600 mt-1">Toegang tot het juristendashboard.</p>

        <form onSubmit={submit} className="space-y-4 mt-6">
          <div>
            <Label>E-mail</Label>
            <Input type="email" value={email} onChange={e => setEmail(e.target.value)} className="mt-1" autoComplete="username" />
          </div>
          <div>
            <Label>Wachtwoord</Label>
            <Input type="password" value={pw} onChange={e => setPw(e.target.value)} className="mt-1" autoComplete="current-password" />
          </div>
          <Button type="submit" disabled={busy} className="w-full bg-[#1e1b4b] hover:bg-[#2a2464] text-white h-11">
            {busy ? 'Bezig...' : 'Inloggen'}
          </Button>
        </form>
      </Card>
    </div>
  );
};

export default Login;
